var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lavContainer",staticClass:"atom-lottie-animation",style:({
    width: _vm.width ? `${_vm.width}px` : '100%',
    height: _vm.height ? `${_vm.height}px` : '100%'
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }